import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from './contexts/CartContext';
import { WishlistProvider } from './contexts/WishlistContext';
import { Layout } from './components/layout/Layout';
import { ScrollToTop } from './components/layout/ScrollToTop';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Concept } from './pages/Concept';
import { CreatorDetail } from './pages/CreatorDetail';
import { Creators } from './pages/Creators';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { OrderConfirmation } from './pages/OrderConfirmation';
import { ProductDetail } from './pages/ProductDetail';
import { Shop } from './pages/Shop';
import { Wishlist } from './pages/Wishlist';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="23vcikoy874a1">
      <CartProvider data-id="element-1" data-mp="23vulg4fe8gqx">
        <WishlistProvider data-id="element-2" data-mp="23ujk0b9f7l2z">
          <ScrollToTop data-id="element-3" data-mp="23t8hsfvmildz" />
          <Routes data-id="element-4" data-mp="3ijxoypkvdyjd">
            <Route element={<Layout data-id="element-6" data-mp="3iiwf2oflbi38" />} data-id="element-5" data-mp="3ikh5c1uvgeva">
              <Route index element={<Home data-id="element-8" data-mp="3ii4s22026sok" />} data-id="element-7" data-mp="3ijpbavgxap74" />
              <Route path="boutique" element={<Shop data-id="element-10" data-mp="3mk85uxa7a9d0" />} data-id="element-9" data-mp="3ml14tc2x3ukl" />
              <Route path="produit/:productId" element={<ProductDetail data-id="element-12" data-mp="3rbr9so7flver" />} data-id="element-11" data-mp="3mjpyp5m02aqb" />
              <Route path="createurs" element={<Creators data-id="element-14" data-mp="3reltuemj9e7n" />} data-id="element-13" data-mp="3rdkgu4lyihna" />
              <Route path="createurs/:creatorId" element={<CreatorDetail data-id="element-16" data-mp="5gg5d4r3wxg" />} data-id="element-15" data-mp="6hqffdy0fe4" />
              <Route path="concept" element={<Concept data-id="element-18" data-mp="2zlv7cvunj3vl" />} data-id="element-17" data-mp="2zl3a7gleoy37" />
              <Route path="panier" element={<Cart data-id="element-20" data-mp="2zng0qi58cgrv" />} data-id="element-19" data-mp="2zmo3z3zwcd00" />
              <Route path="favoris" element={<Wishlist data-id="element-22" data-mp="33nges1of2pye" />} data-id="element-21" data-mp="33mf6g4yschkd" />
              <Route path="commande/confirmation" element={<OrderConfirmation data-id="element-24" data-mp="38l8h7pmotugu" />} data-id="element-23" data-mp="33orhrza1ftog" />
              <Route path="*" element={<NotFound data-id="element-26" data-mp="38o4fxg6d0n6c" />} data-id="element-25" data-mp="38k6w0sbyjrle" />
            </Route>
            <Route path="commande" element={<Checkout data-id="element-28" data-mp="3dm5y7yvyoigr" />} data-id="element-27" data-mp="3dlw6o6v9q38y" />
          </Routes>
          <Toaster position="bottom-center" toastOptions={{
          style: {
            background: 'rgb(30 26 22)',
            color: 'rgb(246 241 233)',
            border: 'none',
            borderRadius: '999px',
            fontFamily: 'Inter, system-ui, sans-serif'
          }
        }} data-id="element-29" data-mp="nw2ay2pqvkpi" />
        </WishlistProvider>
      </CartProvider>
    </BrowserRouter>;
}